import React from 'react';
import EditarOrdenCompra from '../../../components/insumos/orden_compra/EditarOrdenCompra';

const EditarOrdenCompraPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <EditarOrdenCompra />
    </div>
  );
};

export default EditarOrdenCompraPage;